const ITEMS = ["AVC", "Demência", "Alzheimer", "Enxaqueca", "Sono", "Esquecimento"];

function Seq({ hidden = false }) {
  return (
    <span className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="px-7 md:px-10 font-display italic text-2xl md:text-4xl whitespace-nowrap">
            {item}
          </span>
          <svg viewBox="0 0 24 24" className="size-4 md:size-5 shrink-0 text-sun" fill="currentColor" aria-hidden="true">
            <path d="M12 0l2.4 8.1L22 6.1l-5.6 6 5.6 6-7.6-2L12 24l-2.4-7.9-7.6 2 5.6-6-5.6-6 7.6 2z" />
          </svg>
        </span>
      ))}
    </span>
  );
}

export default function Marquee() {
  return (
    <section className="relative z-20 overflow-hidden py-8" data-testid="marquee" aria-label="Abordagens">
      <div className="w-[112%] -ml-[6%] -rotate-1 bg-terra py-4 md:py-5 overflow-hidden shadow-xl shadow-olive-deep/30">
        <div className="marquee-track text-cream">
          <Seq />
          <Seq hidden />
        </div>
      </div>
    </section>
  );
}
